export interface ResourceArticleMeta {
    slug: string;
    title: string;
    excerpt: string;
    image: string;
    translationKey: string;
}

export const resourcesArticles: ResourceArticleMeta[] = [
    {
        slug: 'funding-your-education',
        title: "Funding Your Sport: An Athlete's Guide to Getting Started",
        excerpt: 'Set up your fund page, tell your athletic story, and start receiving support from family, friends, club and sponsors.',
        image: '/resources/athlete-training.jpg',
        translationKey: 'fundingYourEducation',
    },
    {
        slug: 'smart-fundraising-guide',
        title: 'Smart Fundraising: Strategies That Actually Work for Athletes',
        excerpt: 'Set realistic targets, craft compelling training updates, and build momentum toward a season or competition goal.',
        image: '/resources/team-huddle.jpg',
        translationKey: 'smartFundraisingGuide',
    },
    {
        slug: 'engaging-your-supporters',
        title: 'Engaging Your Supporters: Keep Family, Friends & Club in the Loop',
        excerpt: 'Simple ways to share training progress, celebrate milestones, and make every contributor feel part of the journey.',
        image: '/resources/athlete-celebration.jpg',
        translationKey: 'engagingYourSupporters',
    },
    {
        slug: 'supporting-an-athlete',
        title: 'Supporting an Athlete: How Your Contribution Makes a Difference',
        excerpt: 'A guide for family, friends, club members and sponsors — how even small contributions keep an athlete in the game.',
        image: '/resources/coach-and-athlete.jpg',
        translationKey: 'supportingAnAthlete',
    },
    {
        slug: 'snap-raise-alternatives',
        title: 'Snap! Raise Alternatives in 2026: How Athletes Can Keep 100%',
        excerpt: "Snap! Raise takes a cut of what's raised. Sport Fund is free for athletes — they keep 100% of every donation, with recurring support paid straight to the family. An honest comparison.",
        image: '/resources/team-huddle.jpg',
        translationKey: 'snapRaiseAlternatives',
    },
    {
        slug: 'cost-of-youth-sports-2026',
        title: 'How Much Does a Season of Youth Sports Really Cost in 2026?',
        excerpt: 'Fees, travel, gear, tournaments — the real 2026 numbers, and practical ways families cover them without going into debt.',
        image: '/resources/athlete-training.jpg',
        translationKey: 'costOfYouthSports2026',
    },
    {
        slug: 'how-to-fundraise-for-a-sports-season',
        title: 'How to Fundraise for Your Sports Season: 7 Honest Ways That Actually Work (2026)',
        excerpt: "Practical fundraising ideas for individual athletes — recurring supporter asks, sponsor letters, community events and more — without giving up a cut of what you raise.",
        image: '/resources/coach-and-athlete.jpg',
        translationKey: 'howToFundraiseForASeason',
    },
    {
        slug: 'fundraising-letter-template',
        title: 'Sports Fundraising Letter Template: A Free Letter You Can Copy',
        excerpt: 'A copy-paste fundraising letter for athletes — plus how to personalize it, who to send it to, and how to follow up so it actually gets read.',
        image: '/resources/coach-and-athlete.jpg',
        translationKey: 'fundraisingLetterTemplate',
    },
    {
        slug: 'thank-you-message-templates',
        title: 'Thank-You Message Templates for Sports Fundraising Supporters',
        excerpt: 'Free thank-you templates for a one-time gift, a new monthly supporter, and a season-end wrap-up — copy, personalize, and send.',
        image: '/resources/athlete-celebration.jpg',
        translationKey: 'thankYouMessageTemplates',
    },
    {
        slug: 'how-to-set-a-fundraising-goal',
        title: 'How to Set a Fundraising Goal for Your Sports Season',
        excerpt: "How to add up the season's real costs, split the total into a monthly number, and adjust your goal as the season goes.",
        image: '/resources/athlete-training.jpg',
        translationKey: 'howToSetAFundraisingGoal',
    },
    {
        slug: 'sponsorship-letter-template',
        title: 'Sports Sponsorship Letter Template: A Free Letter for Local Businesses',
        excerpt: 'A copy-paste sponsorship letter for asking local businesses to back an athlete — what to offer in return, how much to ask for, and how to follow up.',
        image: '/resources/team-huddle.jpg',
        translationKey: 'sponsorshipLetterTemplate',
    },
    {
        slug: 'drive-sports-and-team-fundraisers',
        title: 'Drive Sports & Team Fundraising Apps: Where They Leave Individual Athletes Out (2026)',
        excerpt: "Drive Sports and Snap! Raise are built around the team drive, not the individual athlete. Here's what that leaves out, and where Sport Fund fits.",
        image: '/resources/coach-and-athlete.jpg',
        translationKey: 'driveSportsAndTeamFundraisers',
    },
    {
        slug: 'spotfund-vs-sport-fund',
        title: 'Sport Fund vs Spotfund NIL: Not the Same Platform (2026)',
        excerpt: 'Similar-sounding names, different platforms. Spotfund NIL is built for college NIL collectives; Sport Fund is built for one individual athlete at a time.',
        image: '/resources/athlete-training.jpg',
        translationKey: 'spotfundVsSportFund',
    },
    {
        slug: 'recurring-vs-one-time-donations',
        title: 'Recurring Monthly Donations vs. One-Time Gifts for Athletes',
        excerpt: "One $500 ask is hard to make and easy to say no to. Here's why recurring monthly support outraises one-time asks over a season — and how to ask for it.",
        image: '/resources/athlete-celebration.jpg',
        translationKey: 'recurringVsOneTimeDonations',
    },
];
